export function getGlobal<T>(name: string): T {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	return (window as Record<string, any>)[name] as T
}
